import { showModal } from './modules/modal.js';
import fitvids from 'fitvids';
import NiceSelect from '../../node_modules/nice-select2/dist/js/nice-select2.js';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import Form from './modules/Form.js';

// Add scrolled class to the body when page is scrolled
if (window.scrollY > 80) {
	document.body.classList.add("scrolled");
}

window.addEventListener('scroll', function () {
	if (window.scrollY > 80) {
			document.body.classList.add("scrolled");
	} else {
			document.body.classList.remove("scrolled");
	}
});

/**
 * Scroll the page to the top
 */
function scrollToTop() {
	window.scroll({top: 0, left: 0, behavior: 'smooth'});
}

// Fitvids - Keep videos contained and proportional
// Add Google maps as an additional target
fitvids({
	players: "iframe[src^='https://www.google.com/maps']"
});

//// Add NiceSelect UI to multiselect fields
let multiSelects = document.querySelectorAll("select[multiple]");
if(multiSelects.length) {
	let multiSelectOptions = {
		placeholder: 'Select one or more'
	};
	multiSelects.forEach(function(multiSelect) {
		let placeholderText = multiSelect.dataset.placeholder;
		if(placeholderText) {
			multiSelectOptions.placeholder = placeholderText;
		}
		new NiceSelect(multiSelect, multiSelectOptions);
	});
}

// Change the style of the category nav when it sticks to the top
const homeCatNav = document.querySelector("#home .categories-nav");
let isPinned = false;

// Event listener to track scroll position
window.addEventListener('scroll', () => {
	if(homeCatNav) {
		const elementTop = homeCatNav.getBoundingClientRect().top;
		if (elementTop <= 78) {
			if (!isPinned) {
				homeCatNav.classList.add('is-pinned');
				isPinned = true;
			}
		} else {
			if (isPinned) {
				homeCatNav.classList.remove('is-pinned');
				isPinned = false;
			}
		}
	}
});

// Open or close the mobile nav
function toggleMobileNav(hamburger) {
	if(hamburger.classList.contains("active")) {
		// Menu is open - close it
		hamburger.classList.remove("active");
		document.body.classList.remove("nav-open");
	}
	else
	{
		// Menu is closed - open it
		hamburger.classList.add("active");
		document.body.classList.add("nav-open");
	}
}

// Open or close the search
function toggleSearchForm() {
	if(document.body.classList.contains('search-open')) {
		document.body.classList.remove('search-open');
		document.body.classList.remove('results-in');
		// Clear the search input
		let desktopSearchInput = document.querySelector('form#desktop-search input[name=s]');
		desktopSearchInput.value = '';
		// Hide the search results count
		let searchResultsCount = document.querySelector('.search-overlay .form-holder .result_count .text');
		if(searchResultsCount) {
			searchResultsCount.classList.remove('visible');
		}
		// Fade out and hide the search results
		let searchResults = document.querySelector('#search-results');
		if(searchResults) {
			searchResults.style.opacity = 0;
			searchResults.addEventListener('transitionend', () => {
				searchResults.classList.remove('d-block');
				let searchResultsRow = searchResults.querySelector('.row');
				if(searchResultsRow) {
					searchResultsRow.innerHTML = '';
				}
			}, {once: true});
		}
	}
	else {
		document.body.classList.add('search-open')
	}
}

// Function to change stylesheet rules
function changeStylesheetRule(stylesheet, selector, property, value) {
	selector = selector.toLowerCase();
	property = property.toLowerCase();
	value = value.toLowerCase();

	for(var i = 0; i < stylesheet.cssRules.length; i++) {
		var rule = stylesheet.cssRules[i];
		if(rule.selectorText === selector) {
			rule.style[property] = value;
			return;
		}
	}
	
	stylesheet.insertRule(selector + " { " + property + ": " + value + "; }", 0);
}

// Add listener for click events
document.addEventListener('click',function(event) {

	// Clicks on hamburger menu
	if(event.target.closest('.hamburger')) {
		let hamburger = event.target.closest('.hamburger');
		toggleMobileNav(hamburger);
	}

	// Clicks on search icon
	if(event.target.closest('.search-icon')) {
		toggleSearchForm();
	}

	// Clicks on article sub-categories
	if(event.target.matches('#article_category .filter-nav > .filter')) {
		event.preventDefault();
		filterArticles(event.target);
	}

	// Clicks on 'load more' buttons
	if(event.target.matches('.btn-load-more')) {
		loadMore(event.target);
	}

	// Clicks on directory category filter links
	if(event.target.matches('.directory-category-filter .dropdown-item[data-cat]')) {
		filterDirectory(event.target);
	}

});

// Add listener for change events
document.addEventListener("change", function(event) {

	// Tick the mailchimp checkboxes when the multi-select box options are changed
	if(event.target.matches('.mce-publications')) {
		let form = event.target.closest('form');
		let selectedData = event.target.selectedOptions;
		let checkboxes = form.querySelectorAll("input[type='checkbox'][name^='group[6720]']");
		if(checkboxes.length) {
			for (let i = 0; i < checkboxes.length; i++) {
				checkboxes[i].checked = false;
			}
		}
		let checkbox;
		if(selectedData.length) {
			for (let i = 0; i < selectedData.length; i++) {
				checkbox = form.querySelector("input[name='group[6720]["+selectedData[i].value+"]']");
				if(checkbox) {
					checkbox.checked = true;
				}
			}
		}
	}

});

var coverFeatureSwiper;

// Homepage carousel
function coverFeatureBreakpointChecker(coverFeatureBreakpoint) {
	let coverFeatures = document.querySelector('#cover-features-carousel');
	let slides = coverFeatures.querySelectorAll('.banner');
	let slidecount = slides.length;
	if(coverFeatureBreakpoint.matches === true) {
		slides.forEach(function(slide) {
			slide.removeAttribute('style');
		});
		enableCoverFeatureCarousel();
	} else if ( coverFeatureBreakpoint.matches === false ) {
		// Hide all slides
		slides.forEach(function(slide) {
			slide.style.display = 'none';
		});
		// Kill the carousel
		if(coverFeatureSwiper) {
			coverFeatureSwiper.destroy( true, true );
		}
		// Show a random slide
		let rand = Math.floor(Math.random() * (slidecount));
		slides[rand].style.display = 'block';
	}
};

function enableCoverFeatureCarousel() {

	// Get the right stylesheet
	let homepageBannerStyles;
	let stylesheets = document.styleSheets;
	for(let i = 0; i < stylesheets.length; i++) {
		if(stylesheets[i].ownerNode.id === 'header-styles') {
			homepageBannerStyles = stylesheets[i];
		}
	}

	coverFeatureSwiper = new Swiper('#cover-features-carousel', {
		modules: [Autoplay, Pagination, EffectFade],
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 8000,
			disableOnInteraction: false
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		}
	});
	
	coverFeatureSwiper.on('activeIndexChange',function(swiper){
		let activeSlide = swiper.slides[swiper.activeIndex];
		if(activeSlide) {
			let theme = activeSlide.dataset.theme;
			let navColour = activeSlide.dataset.navLinks;
			let oxColour = activeSlide.dataset.logoOx;
			let magColour = activeSlide.dataset.logoMagazine;

			let headerAlt = document.querySelector('#header-alt');
			if(theme && headerAlt) {
				headerAlt.classList.remove('dark_theme','light_theme');
				headerAlt.classList.add(theme+'_theme');
			}

			if(navColour) {
				changeStylesheetRule(homepageBannerStyles, '.home-nav .nav-item .nav-link', 'color', navColour);
			}
			if(oxColour) {
				changeStylesheetRule(homepageBannerStyles, '#home svg .ox-fill', 'fill', oxColour);
			}
			if(magColour) {
				changeStylesheetRule(homepageBannerStyles, '#home svg .mag-fill', 'fill', magColour);
			}

		}
	});
	
};

let coverFeatureCarousel = document.querySelector('#cover-features-carousel');
if(coverFeatureCarousel) {
	let coverFeatureBreakpoint = window.matchMedia( '(min-width:768px)' );

	// When breakpoints are hit
	coverFeatureBreakpoint.addEventListener("change", () => {
		coverFeatureBreakpointChecker(coverFeatureBreakpoint);
	});

	// On page load
	coverFeatureBreakpointChecker(coverFeatureBreakpoint);
	
}

// Article templates...

// Context aware images
/**
 * Initialise the context aware images.
 * Uses Swiper with a fade transition and manual swipe turned off
 */
function initContextAware() {
	let contextAware = document.querySelector('#context_aware');
	if(contextAware) {
		// Initialise the slider
		let sliderElement = contextAware.querySelector('#sticky_image');
		if(sliderElement) {
			new Swiper(sliderElement, {
				modules: [EffectFade],
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				speed: 1000,
				on: {
					init: function () {
						activateContextAware(this,contextAware);
					}
				}
			});
		}
	}
}

const articleCarouselElement = document.querySelector('#carousel .carousel');
if(articleCarouselElement) {
	new Swiper(articleCarouselElement, {
		modules: [Navigation, Pagination],
		speed: 1000,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		}
	});
}

/**
 * Activate the context aware article using intersection observer to transition slides when the anchor is passed
 * @param {Swiper} slider Swiper object
 * @param {HTMLElement} contextAware Contect aware wrapper element
 */
function activateContextAware(slider,contextAware) {
	// Find all the anchors
	let article = contextAware.querySelector("article");
	if(article) {
		let anchors = article.querySelectorAll('a[id^=trigger_]');
		
		const observer = new IntersectionObserver((entries) => {
      for (let entry of entries) {
        let anchorId = entry.target.id;
				let slideIndex = anchorId.replace('trigger_','');
        if(entry.isIntersecting) {
					slider.slideTo(slideIndex);
        }
      }
    }, { threshold: 0.8 });

    // Observe each block anchor
    for (let anchor of anchors) {
      observer.observe(anchor);
    }
	}
}
initContextAware();

/**
 * Filter the article grid to a sub-category
 * @param {htmlElement} link Clicked category 
 */
function filterArticles(link) {

	let activeLink = document.querySelector('#article_category .filter-nav > a.active');
	let loadmoreBtn = document.querySelector('.btn-load-more');

	// Load the articles
	let articleGrid = document.querySelector("#article_grid");
	if(!articleGrid) {
		return;
	}
	let cat = link.dataset.keyword;
	let catId = link.dataset.id;

	let postData = new FormData();
	postData.append("cats", cat);

	fetch(theme_url + "ajax/get_article_cards.php", {
		method: "POST",
		body: postData,
		credentials: 'same-origin'
	}).then(response => response.text())
	.then(data => {
		if(data) {
			// Load the grid into the article grid space
			articleGrid.innerHTML = data;
			// Remove the active class from exisiting menu items
			if(activeLink) {
				activeLink.classList.remove('active');
			}
			// Add the active class to the clicked link
			link.classList.add('active');
			// Update the load more button data
			if(loadmoreBtn) {
				loadmoreBtn.dataset.category = catId;
				let cards = document.querySelectorAll('#cat-articles .card');
				let cardCount = cards.length;
        loadmoreBtn.dataset.skip = cardCount;
			}
		}
	});

	// Load the related content
	let relatedContent = document.querySelector('#related_content');
	if(!relatedContent) {
		return;
	}
	let source = 'mag_category';
	let refId = link.dataset.id;

	let relData = new FormData();
	relData.append("source", source);
	relData.append("refID", refId);

	fetch(theme_url + "ajax/get_related.php", {
		method: "POST",
		body: relData,
		credentials: 'same-origin'
	}).then(response => response.text())
	.then(data => {
		if(data) {
			// Load the content into the related content space
			relatedContent.innerHTML = data;
		}
	});
}

// "Load more" buttons
function loadMore(btn) {
	let catId = btn.dataset.category;
	let target = btn.dataset.target;
	let targetElement = document.querySelector('#'+target);
	if(!targetElement) {
		return;
	}
	let skip = btn.dataset.skip;
	btn.classList.add('running');
	btn.disabled = true;

	let postData = new FormData();
	postData.append("cat", catId);
	postData.append("skip", skip);

	fetch(theme_url + "ajax/article-cards-pager.php", {
		method: "POST",
		body: postData,
		credentials: 'same-origin'
	}).then(response => response.text())
	.then(data => {
		if(data !== '') {
			// Append the new HTML
			targetElement.innerHTML += data;
			// Get the new card count
			let cards = targetElement.querySelectorAll('.card');
			let cardCount = cards.length;
			// Update the button data attributes
			btn.dataset.skip = cardCount;
			btn.disabled = false;
		}
		else {
			btn.innerText = 'No more posts';
		}
		setTimeout(function(){
			btn.classList.remove('running');
		},500);
	});
}

var field, field_block;

// Float Labels

// Add focus class to filled fields on page load
var inputFields = document.querySelectorAll('.float-label input');
inputFields.forEach(function (input) {
	if (input.value.length > 0) {
		input.closest('.float-label').classList.add('focus');
	}
});


// When field is focused
document.addEventListener('focus', function (event) {
  var target = event.target;
  if (target.classList.contains('form-control')) {
    field = target;
    field_block = field.closest('.float-label');
    if (!field.disabled) {
      field_block.classList.add('focus');
    }
  }
}, true);

// When field loses focus
document.addEventListener('blur', function (event) {
  var target = event.target;
  if (target.classList.contains('form-control')) {
    field = target;
    field_block = field.closest('.float-label');
    if (field.value.length === 0) {
      field_block.classList.remove('focus');
    }
  }
}, true);

/**
 * Filter the directory grid by category
 * @param {htmlElement} trigger The element clicked to trigger this function
 */
function filterDirectory(trigger) {
	let dropDownMenu = trigger.closest('.dropdown-menu');
	if(dropDownMenu) {
		let allTriggers = dropDownMenu.querySelectorAll('.dropdown-item');
		allTriggers.forEach(function(item) {
			item.classList.remove('active');
		});
	}
	trigger.classList.add('active');
	let cat = trigger.dataset.cat;
	let target = trigger.dataset.target;
	if(!cat || !target) {
		return;
	}
	let targetElement = document.querySelector('.'+target);
	if(targetElement) {
		let allItems = targetElement.querySelectorAll('.directory-card-column');
		let itemCount = 0;
		if(allItems.length) {
			allItems.forEach(function(item) {
				item.style.display = 'none';
				if(item.classList.contains('cat-'+cat)) {
					item.style.display = 'flex';
					itemCount++;
				}
			});
		}
		let countElement = document.querySelector('.dir-count');
		if(countElement) {
			let countText = itemCount;
			countText += ' business';
			countText += itemCount != 1 ? 'es' : '';
			countElement.innerText = countText;
		}
	}
}

// Form submissions
document.addEventListener("submit", function (event) {
  if(event.target.matches(".tr-form")) {
    let form = new Form(event.target);
    form.submit(event);
  }
});
